module.exports = __webpack_public_path__ + "img/sm-1.c3c1c016.png";